import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';

const required = str => !isEmpty(str);

export default {
	validators: {
		email: { required, isEmail }
	},
	messages: {
		email:{
			required: 'forgot_password_email_required',
			isEmail: 'forgot_password_email_invalid'
		}
	}
}